// @flow
import { createSelector } from 'reselect';

import { selectCartProductOwner, selectCartReselleeID } from '@gandi/cart';

import { selectShopCurrent } from '../../modules/organization/selectors';

import type { FullState } from '../../types';

export const selectDomainOwnerId: FullState => string = createSelector(
  [
    // $FlowFixMe[incompatible-call]
    state => selectShopCurrent(state, true),
    selectCartReselleeID,
    selectCartProductOwner,
  ],
  (currentOrganization, cartReselleeId, cartProductOwner) => {
    const isReseller = currentOrganization?.reseller ?? false;
    const hasResellee =
      cartReselleeId && currentOrganization?.id !== cartReselleeId;

    let domainOwnerId = currentOrganization?.id;
    if (isReseller && hasResellee) {
      domainOwnerId = cartReselleeId;
    } else if (!isReseller && cartProductOwner) {
      domainOwnerId = cartProductOwner;
    }

    return domainOwnerId;
  },
);
